module.exports = __webpack_public_path__ + "media/images/front/noimage_180x180-8bdd16cb86ad34e4d36128d0cb045639.png";